/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="106.19"
        height="94.33"
        viewBox="0 0 106.19 94.33"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M97.94 36.16a1.26 1.26 0 0 1 1.67-.09l.1.09 6.12 6.12a1.25 1.25 0 0 1 .09 1.67l-.09.1-6 6a1.25 1.25 0 0 1-1.86-1.67l.09-.11 5.12-5.11-5.23-5.24a1.25 1.25 0 0 1-.09-1.67Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M104.42 41.92a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22H84.03a1.25 1.25 0 0 1-1.25-1.25 1.27 1.27 0 0 1 1.13-1.25h20.51ZM6.48 36.16a1.25 1.25 0 0 1 1.77-.07 1.23 1.23 0 0 1 .09 1.73l-.09.1-5.23 5.24 5.12 5.11a1.26 1.26 0 0 1 .09 1.67l-.09.1a1.23 1.23 0 0 1-1.67.09l-.1-.09-6-6a1.27 1.27 0 0 1-.1-1.67l.1-.1Z"
          className="icon-fill icon-accent"/><path
          fill="#ffb81c"
          d="M22.14 41.92a1.25 1.25 0 0 1 1.23 1.27 1.27 1.27 0 0 1-1.1 1.22H1.75a1.25 1.25 0 0 1-1.31-1.19 1.24 1.24 0 0 1 1.18-1.31h20.52Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M91.29 71.5a1.27 1.27 0 0 1 1.25 1.13v8.78a1.22 1.22 0 0 1-1.12 1.23H82.8a1.24 1.24 0 0 1-1.25-1.25 1.28 1.28 0 0 1 1.13-1.25h7.36v-7.4a1.28 1.28 0 0 1 1.13-1.25Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M75.67 65.77a1.22 1.22 0 0 1 1.62-.1l.1.09 14.42 14.41a1.26 1.26 0 0 1 0 1.77 1.25 1.25 0 0 1-1.67.09l-.1-.09-14.41-14.45a1.24 1.24 0 0 1 .04-1.72ZM23.41 3.6a1.27 1.27 0 0 1 1.23 1.28 1.25 1.25 0 0 1-1.1 1.21h-7.53v7.25a1.26 1.26 0 0 1-1.13 1.24h-.12a1.28 1.28 0 0 1-1.28-1.08V4.85a1.25 1.25 0 0 1 1.12-1.24h8.81Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M14.29 4.34a1.24 1.24 0 0 1 1.66-.09l.11.09 14.41 14.41a1.25 1.25 0 0 1-1.66 1.86l-.1-.09L14.29 6.1a1.24 1.24 0 0 1 0-1.76ZM91.42 3.6a1.26 1.26 0 0 1 1.24 1.12v8.62a1.252 1.252 0 1 1-2.5.13V6.1h-7.4a1.25 1.25 0 0 1-1.28-1.12v-.13a1.25 1.25 0 0 1 1.13-1.24h8.81Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M90.17 4.34A1.25 1.25 0 0 1 92.02 6l-.09.1-14.45 14.4a1.25 1.25 0 0 1-1.86-1.66l.09-.1ZM14.84 71.5a1.26 1.26 0 0 1 1.24 1.13v7.53h7.21a1.24 1.24 0 0 1 1.24 1.12v.13a1.23 1.23 0 0 1-1.08 1.26h-8.64a1.26 1.26 0 0 1-1.25-1.12v-8.78a1.24 1.24 0 0 1 1.21-1.26Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M28.74 65.77a1.26 1.26 0 0 1 1.77 0 1.24 1.24 0 0 1 .09 1.66l-.12.07-14.39 14.45a1.27 1.27 0 0 1-1.77 0 1.25 1.25 0 0 1-.09-1.67l.09-.1Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M54.34 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M53.09 59.59a1.24 1.24 0 0 1 1.2 1.08V82.9a1.24 1.24 0 0 1-1.23 1.25 1.27 1.27 0 0 1-1.25-1.12V60.84a1.25 1.25 0 0 1 1.25-1.26Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M44.94 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M43.69 38.25a1.25 1.25 0 0 1 1.24 1.13v43.57a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09V39.5a1.25 1.25 0 0 1 1.25-1.25Z"
          className="icon-fill icon-base"/>
        <path
          fill="#fff"
          d="M60.2 22.84a11.39 11.39 0 0 1 11.4 11.09V58.5a3.9 3.9 0 0 1-3.69 3.68h-5.43A1.24 1.24 0 0 1 61.17 61a1.25 1.25 0 0 1 1.18-1.32h5.36a1.37 1.37 0 0 0 1.38-1.26V34.23a8.89 8.89 0 0 0-8.61-8.89H45.97a8.9 8.9 0 0 0-8.9 8.63v24.28a1.39 1.39 0 0 0 1.22 1.42h5.36a1.27 1.27 0 0 1 1.23 1.28 1.25 1.25 0 0 1-1.1 1.21h-5.34a3.89 3.89 0 0 1-3.9-3.62V34.23a11.4 11.4 0 0 1 11.1-11.39Z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M62.48 82.94v11.39"/>
        <path
          fill="#fff"
          d="M63.73 82.94v11.39h-2.5V82.94h2.5z"
          className="icon-fill icon-base"/>
        <path
          fill="none"
          d="M62.48 39.5v43.44"/>
        <path
          fill="#fff"
          d="M62.48 38.25a1.25 1.25 0 0 1 1.24 1.13v43.57a1.24 1.24 0 0 1-1.28 1.21 1.26 1.26 0 0 1-1.21-1.09V39.5a1.25 1.25 0 0 1 1.25-1.25ZM53.09 0a9.83 9.83 0 1 0 9.83 9.84A9.84 9.84 0 0 0 53.09 0Zm0 2.5a7.33 7.33 0 1 1-7.32 7.34 7.34 7.34 0 0 1 7.32-7.34Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'PersonWithOutwardArrowsIcon';

export default Icon;
